import { isWithinInterval, parseISO } from 'date-fns';
import { ProgramDate } from '../../models';

export const isWindowActive = (programDate: ProgramDate, now: Date = new Date()): boolean =>
  isWithinInterval(now, {
    start: parseISO(programDate.startDate),
    end: parseISO(programDate.endDate),
  });
